import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1oesixpi34: FaireBrandEntity = {
  token: "b_1oesixpi34",
  type: "brand",
  name: "Piecework",
  avatarUrl:
    "https://cdn.faire.com/fastly/5cd0d2fc016f1d00672a07e67b75d3025db1d5618fa08048f2bda9389fe35537.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/282e8f11a9de6ca885a1470b3976c8a76fe3925dac175f049d6f8b3828377eda.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5cd0d2fc016f1d00672a07e67b75d3025db1d5618fa08048f2bda9389fe35537.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/282e8f11a9de6ca885a1470b3976c8a76fe3925dac175f049d6f8b3828377eda.jpeg",
  location: "CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 173,
  isTopShop: true,
  isInsider: true,
  description:
    "Piecework is a curated line of puzzles, gifts, and goods designed to make your heart sing.\n\nWe started with jigsaw puzzles, bold, beautiful, and joyful by design, and we haven’t stopped since. What began as a rainy-weekend discovery has grown into a celebration of slowing down, sparking delight, and giving great gifts (to yourself or anyone else deserving).\n\nToday, Piecework is more than puzzles. We’ve launched an ever-growing collection of colorful, whimsical, beautifully packaged products, from 100% linen cocktail napkins to hand-picked treasures from brands we love. Our online shop is a destination for goods with personality: gifts, trinkets, tchotchkes, and joyful objects that make any moment a little more memorable.\n\nOur name is still a nod to the process: fitting things together piece by piece, moment by moment. Whether you’re lighting a candle, pouring a cocktail, or unboxing a puzzle, we believe in the small pleasures that add up to something meaningful.\n\nWelcome to Piecework. The puzzle party’s just getting started.\n\nXo Piecework",
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:28:42.167Z",
    importedBy: "entity-db-cli",
  },
};
